import { render, staticRenderFns } from "./AddEndereco.vue?vue&type=template&id=1a9ba2a4"
import script from "./AddEndereco.vue?vue&type=script&lang=js"
export * from "./AddEndereco.vue?vue&type=script&lang=js"
import style0 from "./AddEndereco.vue?vue&type=style&index=0&id=1a9ba2a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports